<script setup lang="ts">
</script>

<template>
  <div class="hello">
    <h1>Hello Component</h1>
  </div>
</template>

<style scoped>
</style>